import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("hc_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("hc_token"); setUser(false); });
  }, []);

  const authenticate = async (mode, username, password) => {
    const { data } = await api.post(`/auth/${mode}`, { username, password });
    localStorage.setItem("hc_token", data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("hc_token"); setUser(false); };

  return <AuthCtx.Provider value={{ user, authenticate, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
